<app-page-header
  [title]="i18n.t('storyboard.title')"
  [subtitle]="i18n.t('storyboard.subtitle')"
  [icons]="headerIcons">
</app-page-header>

<div class="scene-container shadow">
    <div class="right-container">
        <app-storyboard-settings 
            [showSettings]="showSettings"
            (showSettingsChange)="onShowSettingsChange($event)"
            (settingsChange)="onSettingsChange($event)">
        </app-storyboard-settings>
        <table>
            <thead>
                <tr>
                    <th>Cut</th>
                    <th>Draft</th>
                    <th>Text</th>
                    <th>Picture</th>
                </tr>
            </thead>
            <tbody>
                <app-storyboard-scene
                    *ngFor="let scene of scenes; let i = index"
                    [scene]="scene"
                    [sceneIndex]="i"
                    [updatedImageUrl]="updatedImageUrl"
                    (textChange)="onTextChange($event)"
                    (expressEdit)="onExpressEdit($event)"
                    (canvasReady)="onCanvasReady($event)">
                </app-storyboard-scene>
            </tbody>
        </table>
        <div class="scene-actions">
            <button class="add-scene-button" (click)="addScene()">{{ i18n.t('storyboard.addScene') }}</button>
        </div>
    </div>
</div>

<app-toast></app-toast>
